import ListItemIcon from '@zenbusiness/zui/ListItemIcon';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const IconStep = styled(ListItemIcon)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: '2rem',
  height: '2rem',
  borderRadius: theme.shape.rounded.full,
  backgroundColor: theme.palette.fixed.black,
  color: theme.palette.fixed.white,
  fontSize: '0.75rem',

  [theme.breakpoints.up('md')]: {
    minWidth: '2.5rem',
    height: '2.5rem',
    fontWeight: 'bold',
    fontSize: '1rem'
  }
}));

export const Description = styled(Text)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  wordBreak: 'break-word',
  whiteSpace: 'normal'
}));

export const SubDescription = styled(Text)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5)
}));
